import {
  connect,
} from 'react-redux'

import {
  Form,
} from 'antd'

import {
  sendingContact,
} from '../../actions'

import {
  CONTACT_EP,
} from '../../constant'

import Footer from '../../components/layouts/footer'

const wrappedFooter = Form.create()(Footer)

const mapStateToProps = (state) => {
  return {
    responseStatus: state.contact.responseStatus,
  }
}

const mapDispatchToProps = dispatch => ({
  loadHandleSendContact (value) {
    dispatch(sendingContact(CONTACT_EP, value))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(wrappedFooter)



// WEBPACK FOOTER //
// ./src/containers/layouts/Footer.js